import type { Store } from '@reduxjs/toolkit';
import StoreHolder from './storeHolder';

export function TeactReduxProvider({ store, children }: { store: Store; children: any }) {
  StoreHolder.setStore(store);

  return children;
}
